<template>
  <div class="nobreak">
    <h3 class="text-lg font-medium text-gray-800 mb-2">{{ $gettext("Documents") }}</h3>
    <ul v-if="documents?.length" class="text-sm divide-y divide-gray-200 border rounded-md">
      <li v-for="doc in documents" :key="doc.id" class="flex justify-between items-center px-3 py-2">
        <span class="text-gray-700 font-medium">
          {{ categoryLabels[doc.attributes.categoryName] || doc.attributes.categoryName }}
        </span>
        <span class="text-gray-500">
          {{ doc.attributes.file?.name || $gettext("Sans fichier") }}
        </span>
      </li>
    </ul>
    <p v-else class="text-sm text-gray-500 italic">
      {{ $gettext("Aucun document disponible") }}
    </p>
  </div>
</template>

<script setup>
import { useGettext } from "vue3-gettext";
const { $gettext } = useGettext();

defineProps({
  documents: Array
});

const categoryLabels = {
  signatoryDocuments: $gettext("Document d'identité du signataire à la mission"),
  legalRepresentatives: $gettext("Statuts coordonnés"),
  physicalPersonEngagement: $gettext("Disposition régissant le pouvoir d'engager la personne morale"),
  administrators: $gettext("Liste des administrateurs"),
  uboRegisterExtract: $gettext("Extrait du registre des bénéficiaires effectifs"),
  identityDocuments: $gettext("Document d'identité"),
  otherDocuments: $gettext("Autre document(s)"),
  saleListingAgreement: $gettext("Compromis de vente"),
  signedPurchaseAgreement: $gettext("Compromis de vente signé"),
  signedPurchaseOffer: $gettext("Offre d'achat signée")
}
</script>
